@if (email(); as e) {
  <div class="flex flex-col gap-4">
    <div class="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
      <div class="flex items-center gap-2 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
        <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-indigo-100 text-indigo-600">
          <i class="pi pi-envelope text-sm"></i>
        </span>
        <span class="text-xs font-semibold text-slate-700 uppercase tracking-wide">Información del correo</span>
      </div>
      <div class="p-4">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
          <div class="sm:col-span-2">
            <p class="text-xs font-medium text-slate-500">Asunto</p>
            <p class="text-sm font-semibold text-slate-900">{{ e.subject || '—' }}</p>
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Estado</p>
            <p-tag [value]="statusLabel(e.status)" [severity]="statusSeverity(e.status)" [title]="statusTooltip(e.status) ?? ''"
              class="text-xs" />
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Plantilla</p>
            <p class="text-sm text-slate-700 font-mono">{{ e.template || '—' }}</p>
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Cliente</p>
            @if (e.customerId && customerDisplayName(e)) {
              <button
                type="button"
                class="text-sm font-medium text-indigo-600 hover:text-indigo-800 hover:underline mt-0.5"
                (click)="onOpenCustomer(e)">
                {{ customerDisplayName(e) }}
              </button>
            } @else {
              <p class="text-sm text-slate-700">—</p>
            }
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Venta</p>
            @if (e.saleId) {
              <button
                type="button"
                class="text-sm font-medium text-indigo-600 hover:text-indigo-800 hover:underline mt-0.5"
                (click)="onOpenSale(e)">
                {{ e.saleNumber || ('Venta #' + e.saleId) }}
              </button>
            } @else {
              <p class="text-sm text-slate-700">—</p>
            }
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Suscripción</p>
            @if (e.subscriptionId) {
              <button
                type="button"
                class="text-sm font-medium text-indigo-600 hover:text-indigo-800 hover:underline mt-0.5"
                (click)="onOpenSubscription(e)">
                {{ e.subscriptionNumber || ('Suscripción #' + e.subscriptionId) }}
              </button>
            } @else {
              <p class="text-sm text-slate-700">—</p>
            }
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Liga de pago</p>
            @if (e.saleLinkId) {
              <button
                type="button"
                class="text-sm font-medium text-indigo-600 hover:text-indigo-800 hover:underline mt-0.5"
                (click)="onOpenSaleLink(e)">
                {{ e.saleLinkNumber || ('Liga #' + e.saleLinkId) }}
              </button>
            } @else {
              <p class="text-sm text-slate-700">—</p>
            }
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">De</p>
            <p class="text-sm text-slate-700 break-all">{{ e.fromAddress || '—' }}</p>
          </div>
          @if (e.replyTo) {
            <div>
              <p class="text-xs font-medium text-slate-500">Responder a</p>
              <p class="text-sm text-slate-700 break-all">{{ e.replyTo }}</p>
            </div>
          }
          <div [class.sm:col-span-2]="!e.replyTo">
            <p class="text-xs font-medium text-slate-500">Para</p>
            <p class="text-sm text-slate-700 break-all">{{ e.toAddresses || '—' }}</p>
          </div>
          @if (e.ccAddresses) {
            <div class="sm:col-span-2">
              <p class="text-xs font-medium text-slate-500">CC</p>
              <p class="text-sm text-slate-700 break-all">{{ e.ccAddresses }}</p>
            </div>
          }
          @if (e.bccAddresses) {
            <div class="sm:col-span-2">
              <p class="text-xs font-medium text-slate-500">BCC</p>
              <p class="text-sm text-slate-700 break-all">{{ e.bccAddresses }}</p>
            </div>
          }
          @if (e.attachments?.length) {
            <div class="sm:col-span-2">
              <p class="text-xs font-medium text-slate-500 mb-1">Adjuntos</p>
              <ul class="flex flex-col gap-1">
                @for (file of e.attachments; track file.fileId ?? file.name) {
                  <li class="inline-flex items-center gap-2 text-sm text-slate-700">
                    <i class="pi pi-paperclip text-xs text-slate-400"></i>
                    <span class="truncate">{{ file.name || 'archivo' }}</span>
                    @if (file.extension) {
                      <span class="text-xs uppercase text-slate-400">{{ file.extension }}</span>
                    }
                    @if (file.size != null) {
                      <span class="text-xs text-slate-400">{{ formatFileSize(file.size) }}</span>
                    }
                  </li>
                }
              </ul>
            </div>
          }
          <div>
            <p class="text-xs font-medium text-slate-500">Disparado por</p>
            <p class="text-sm text-slate-700">{{ e.triggeredByUserName || e.triggeredByUserEmail || 'Sistema' }}</p>
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Proveedor</p>
            <p class="text-sm text-slate-700">{{ e.provider || '—' }}</p>
          </div>
          @if (e.domain) {
            <div>
              <p class="text-xs font-medium text-slate-500">Dominio</p>
              <p class="text-sm text-slate-700 font-mono">{{ e.domain }}</p>
            </div>
          }
          <div>
            <p class="text-xs font-medium text-slate-500">Fecha de envío</p>
            <p class="text-sm text-slate-700">
              {{ e.sentAt ? (e.sentAt | date:'dd/MM/yyyy HH:mm') : (e.createdAt ? (e.createdAt | date:'dd/MM/yyyy HH:mm') : '—') }}
            </p>
          </div>
          @if (e.status === 'SENT') {
            <div>
              <p class="text-xs font-medium text-slate-500">Apertura</p>
              @if (isOpened(e)) {
                <span class="inline-flex items-center gap-1.5 text-sm font-medium text-blue-600">
                  <i class="pi pi-eye text-sm"></i>
                  Abierto
                </span>
              } @else {
                <p-tag [value]="openedLabel(e)" [severity]="openedSeverity(e)" class="text-xs" />
              }
            </div>
            <div>
              <p class="text-xs font-medium text-slate-500">Fecha de apertura</p>
              <p class="text-sm text-slate-700">
                {{ e.openedAt ? (e.openedAt | date:'dd/MM/yyyy HH:mm') : '—' }}
              </p>
            </div>
            <div>
              <p class="text-xs font-medium text-slate-500">Aperturas</p>
              <p class="text-sm text-slate-700">{{ e.openCount ?? 0 }}</p>
            </div>
          }
          <div>
            <p class="text-xs font-medium text-slate-500">Registrado</p>
            <p class="text-sm text-slate-700">{{ e.createdAt ? (e.createdAt | date:'dd/MM/yyyy HH:mm') : '—' }}</p>
          </div>
        </div>
      </div>
    </div>

    @if (e.errorMessage) {
      <div class="rounded-xl border border-red-200 overflow-hidden bg-white shadow-sm">
        <div class="flex items-center gap-2 px-4 py-2.5 bg-red-50 border-b border-red-200">
          <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-red-100 text-red-600">
            <i class="pi pi-exclamation-triangle text-sm"></i>
          </span>
          <span class="text-xs font-semibold text-red-800 uppercase tracking-wide">Error de envío</span>
        </div>
        <div class="p-4">
          <p class="text-sm text-red-700 whitespace-pre-wrap break-words">{{ e.errorMessage }}</p>
        </div>
      </div>
    }

    <div class="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
      <div class="flex items-center gap-2 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
        <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-sky-100 text-sky-600">
          <i class="pi pi-eye text-sm"></i>
        </span>
        <span class="text-xs font-semibold text-slate-700 uppercase tracking-wide">Contenido</span>
      </div>
      @if (emailBodySrcdoc(e.body); as srcdoc) {
        <iframe
          class="email-body-preview"
          [srcdoc]="srcdoc"
          title="Vista previa del correo"
          sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
        ></iframe>
      } @else {
        <p class="text-sm text-slate-500 px-4 py-3">Sin contenido disponible.</p>
      }
    </div>
  </div>
}
